<template>  
    <div v-if="show">
        <app-erros-box
            :erros="erros"
            v-if="erros.length > 0"
        />

        <div class="upload-wrapper">
            <div class="d-flex justify-content-center align-items-center mb-4 steps-container">
                <div class="step-item step-blue">
                    <span class="step-dot-blue completed"></span>
                    <span class="step-label-blue">Pré-visualização do PDF</span>
                </div>
                <div class="step-line completed"></div>
                <div class="step-item active">
                    <span class="step-dot"></span>
                    <span class="step-label-grey">Anexar PDF Assinado</span>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <div 
                v-if="modoVisualizacao === 'preview'"
                class="d-flex flex-column align-items-center w-100 preview-container"
            >
                <div v-if="carregando" class="loading-overlay">
                    <div class="spinner-container">
                        <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
                        <p class="mt-3 text-primary font-weight-bold">Gerando PDF...</p>
                    </div>
                </div>

                <visualizador-pdf
                    v-else-if="urlPdfBoletimMedicao"
                    :url="urlPdfBoletimMedicao"
                    :nome-arquivo="nomeArquivoPdfBoletimMedicao"
                />
            </div>
            
            <div 
                v-if="modoVisualizacao === 'upload'"
                class="d-flex flex-column align-items-center w-100"
            >
                <div class="flex-grow-1">
                    <div class="alert-success-custom mb-4">
                        <div class="d-flex align-items-center justify-content-center text-center">
                            <i class="fa fa-check-circle-o fa-2x mr-3 text-success"></i>
                            <span class="text-instruction font-weight-500">
                                Agora que você imprimiu e assinou (fisicamente ou digitalmente) o documento em PDF, <br>
                                faça o upload do arquivo assinado.
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="!nomeArquivoExistente" class="d-flex flex-column flex-grow-1 align-items-center w-100">
                    <div class=" mt-5">
                        <i class="fa fa-upload fa-4x text-muted opacity-50"></i>
                    </div>

                    <div class=" mt-5">
                        <p class="text-muted">
                            <i class="fa fa-file-pdf-o mr-1"></i>
                            Apenas arquivos em formato PDF são permitidos
                        </p>
                    </div>
                </div>

                <div class="d-flex flex-grow-1 justify-content-center align-items-center w-100 mb-5">
                    <div class="d-flex justify-content-center align-items-center w-100">
                        <b-form-file
                            v-model="arquivoSelecionado"
                            :placeholder="nomeArquivoExistente || 'Clique ou arraste o arquivo para selecionar'"
                            :browse-text="nomeArquivoExistente ? 'Substituir Arquivo' : 'Selecionar Arquivo'"
                            drop-placeholder="Solte o arquivo PDF aqui..."
                            accept=".pdf,application/pdf"
                            :disabled="desabilitarUploadArquivoPdfAssinado"
                            style="min-width: 400px; max-width: 600px;"
                        />

                        <b-button
                            v-show="arquivoSelecionado"
                            variant="light"
                            v-b-tooltip.hover title="Limpar arquivo selecionado"
                            @click="arquivoSelecionado = null"
                        >
                            <i class="fa fa-times fa-thin text-danger font-weight-bold"></i>
                        </b-button>

                        <b-button
                            v-show="modoVisualizacao === 'upload'"
                            class="ml-3 btn-blue-custom"
                            @click.stop="importarArquivoPdfAssinado"
                            :disabled="desabilitarBtnImportarArquivoPdfAssinado"
                            style="min-width: 130px;"
                        >
                            <i class="fa fa-upload mr-2"></i>
                            Enviar Arquivo Assinado
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VisualizadorPdf from '../../../../../../../shared/components/VisualizadorPdf.vue';
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos.js'

export default {
    components: {
        VisualizadorPdf,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        contratoId: {
            type: String,
            default: null,
        },
        boletimMedicaoId: {
            type: String,
            default: null,
        },
        documentoBoletimMedicao: {
            type: Object,
            default: null,
        },
        tipoAnexoBoletimMedicao: {
            type: Number,
            default: null,
        },
        modoVisualizacao: {
            type: String,
            default: 'preview',
        },
        carregando: {
            type: Boolean,
            default: false,
        },
        nomeArquivoExistente: {
            type: String,
            default: null,
        },
        documentoParaAtualizar: {
            type: Object,
            default: undefined,
        },
    },
    data() {
        return {
            erros: [],
            arquivoSelecionado: null,
            carregandoUpload: false,
            tiposVisualizacaoAssinaturaItens: [
                { item: 'preview', name: 'Pré-visualização de impressão', notEnabled: false },
                { item: 'upload', name: 'Upload de arquivo assinado', notEnabled: false },
            ],
        }
    },
    computed: {
        desabilitarUploadArquivoPdfAssinado() {
            return this.modoVisualizacao !== 'upload';
        },
        desabilitarBtnImportarArquivoPdfAssinado() {
            return !this.arquivoSelecionado || this.modoVisualizacao !== 'upload' || this.carregandoUpload;
        },
        urlPdfBoletimMedicao() {
            if (!this.documentoBoletimMedicao || !this.documentoBoletimMedicao.arquivo) {
                return null;
            }

            const bytes = this.converterBase64EmArrayBytes(this.documentoBoletimMedicao.arquivo);
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            return url;
        },
        nomeArquivoPdfBoletimMedicao() {
            const nomeOriginal = this.documentoBoletimMedicao?.nome
                || this.documentoBoletimMedicao?.nomeArquivo
                || this.documentoBoletimMedicao?.nomeDocumento;

            const nome = (nomeOriginal || '').toString().trim();
            if (!nome) return '';
            return nome.toLowerCase().endsWith('.pdf')
                ? nome
                : `${nome}.pdf`;
        },
    },
    methods: {
        converterBase64EmArrayBytes(base64) {
            const binaryString = atob(base64);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        importarArquivoPdfAssinado() {
            this.carregandoUpload = true;
            this.$store.dispatch('addRequest');

            const dto = {
                arquivo: this.arquivoSelecionado,
                tipo: this.tipoAnexoBoletimMedicao,
            };

            const documentoParaAtualizar = this.documentoParaAtualizar !== undefined
                ? this.documentoParaAtualizar
                : this.documentoBoletimMedicao;
            const documentoBoletimMedicaoId = documentoParaAtualizar?.documentoBoletimMedicaoId;
            const requisicao = documentoBoletimMedicaoId
                ? BoletimMedicaoServicos.atualizarDocumentoBoletimMedicao(this.contratoId, this.boletimMedicaoId, documentoBoletimMedicaoId, dto)
                : BoletimMedicaoServicos.adicionarDocumentoBoletimMedicao(this.contratoId, this.boletimMedicaoId, dto);

            requisicao
            .then(response => {
                const sucesso = response?.success === true || response?.data?.success === true;
                const erros = response?.errors || response?.data?.errors || [];

                if (!sucesso) {
                    if (erros.length > 0) {
                        this.$toast.error(
                            'Não foi possível importar o arquivo selecionado',
                            'Erro',
                            this.$toastConfig.error
                        );

                        this.erros = erros;
                        this.$emit('importacao-nao-realizada', { errors: erros });
                    }
                }

                if (sucesso) {
                    this.$toast.success(
                        'Arquivo importado com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    );

                    this.erros = [];
                    this.arquivoSelecionado = null;
                    this.$emit('importacao-realizada');
                }
            })
            .catch(error => {
                this.$toast.error(
                    'Erro ao importar o arquivo selecionado',
                    'Erro',
                    this.$toastConfig.error
                );

                this.erros = error;
            })
            .finally(() => {
                this.carregandoUpload = false;
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>
<style scoped>
.fa-thin { 
    font-weight: 20 !important; /* valores baixos deixam mais fino */ 
    -webkit-text-stroke: 0.5px white; /* opcional: cria efeito de contorno */ 
}
.b-form-file .custom-file-label::after {
  display: none;
}

.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}
.btn-blue-custom:hover {
    filter: brightness(0.9);
}

.alert-success-custom {
    background-color: #D3ECE2;
    border-radius: 8px;
    padding: 12px 24px;
    max-width: fit-content;
    margin: 0 auto;
}

.steps-container { margin-bottom: 30px; }

.step-label-blue {
    font-size: 0.9rem;
    font-weight: 600;
    color: #23A26D;
}
.step-label-grey {
    font-size: 0.9rem;
    font-weight: 600;
    color: #0F97C7;
}
.step-item {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #0F97C7;
    font-size: 0.9rem;
}

.step-item.active { color: #23A26D; }

.step-blue {
    color: #23A26D;
}

.step-icon-blue {
    color: #23A26D;
    margin-right: 8px;
    font-size: 1.1rem;
}

.step-dot {
    width: 12px;
    height: 12px;
    background-color: #0F97C7;
    border-radius: 50%;
    margin-right: 8px;
}
.step-dot-blue {
    width: 12px;
    height: 12px;
    background-color: #23A26D;
    border-radius: 50%;
    margin-right: 8px;
}

.step-item.active .step-dot { background-color: #0F97C7; }

.step-line {
    width: 60px;
    height: 2px;
    background-color: #dee2e6;
    margin: 0 15px;
}
.step-line.completed { background-color: #007bff; }

.preview-container {
    position: relative;
    min-height: 300px;
    width: 100%;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.spinner-container {
    text-align: center;
}

</style>